import { post, formPost } from "../../../js/http";
import storage from "good-storage";

$(document).ready(function() {
  $(".manage-nav li").click(function() {
    var index = $(this).index();
    $($(".manage-nav li")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
    $($(".manage-content .manage-content-item")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  $(".setfee").click(function() {
    let setFeeLayer = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "setFeeCon",
      closeBtn: 2,
      content: $("#setFee-con"),
      end: function() {
        $("#setFee-con").hide();
      }
    });
    $("#setExpenses").click(function() {
      post("/ApiHome/ApiAction?_ControlName=SetFeeAmountEveryMinuteByPC", {
        UserID: storage.get("userInfo").UserID,
        FeeAmount: $("#feeInput").val()
      }).then(res => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          layer.close(setFeeLayer);
          location.reload();
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  });

  $("#angelLeveldes").click(function() {
    post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC", {
      PackName: "CallMe.PC",
      RuleKey: "ApplyAngelRule"
    }).then(res => {
      if (res.ReturnStatus) {
        window.open(res.Data.Url, "_blank");
      }
    });
  });
});
